import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import "./Sidebar.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
      navigate("/login");
    }
  };

  const isActive = (path) => (path === "/dashboard" ? location.pathname === path : location.pathname.startsWith(path));

  const NavLink = ({ to, icon, label }) => (
    <Link to={to} className={`nav-link ${isActive(to) ? "active" : ""}`}>
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
    </Link>
  );

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon">KTZ</div>
          <div className="logo-text">
            <div className="logo-title">Kwality Tech Zone</div>
            <div className="logo-subtitle">Admin Panel</div>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-section-title">Main</div>
          <NavLink to="/dashboard" icon="HM" label="Dashboard" />
          <NavLink to="/enquiries" icon="ENQ" label="Enquiries" />
          <NavLink to="/quotations" icon="QTN" label="Quotations" />
        </div>

        <div className="nav-section">
          <div className="nav-section-title">Products</div>
          <NavLink to="/products" icon="PL" label="Product List" />
          <NavLink to="/products/browse" icon="BQ" label="Browse for Quotation" />
          <NavLink to="/products/new" icon="ADD" label="Add Product" />
          <NavLink to="/products/bulk-import" icon="IMP" label="Bulk Import" />
          <NavLink to="/products/image-enhancer" icon="AI" label="Image Enhancer" />
        </div>

        <div className="nav-section">
          <div className="nav-section-title">Categories</div>
          <NavLink to="/categories" icon="CL" label="Category List" />
          <NavLink to="/categories/new" icon="ADD" label="Add Category" />
        </div>

        <div className="nav-section">
          <div className="nav-section-title">Templates</div>
          <NavLink to="/quotation-templates" icon="TMP" label="Quotation Templates" />
          <NavLink to="/marketing-controls" icon="MKT" label="Marketing Controls" />
        </div>
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <span className="nav-icon">OUT</span>
          <span className="nav-label">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
